export enum AppErrorLogType {
    Info = '[AppErrorLogType] Info',
    Warning = '[AppErrorLogType] Warning',
    Error = '[AppErrorLogType] Error'
}
